import { render, staticRenderFns } from "./head.vue?vue&type=template&id=6bc5dbe8&scoped=true"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc5dbe8",
  null
  
)

export default component.exports